module.exports = __webpack_public_path__ + "img/29_13.1c02d3bb.png";